import { storedBearer } from './edge-owner';
import { IMPERSONATION_FORBIDDEN_MESSAGE, hasImpersonationRecord, tokenImpersonationSessionId } from './impersonation-storage';

/**
 * Admin v2 "view as user": small, DI-free checks for UI that must behave differently while this tab views as a user.
 * The server is the gate (403 `impersonation_forbidden`); these only keep the UI honest about it.
 */

/** Tooltip on controls whose endpoints the server always refuses under impersonation. */
export const VIEW_AS_USER_UNAVAILABLE_TOOLTIP = 'Not available while viewing as a user';

/** An `AUTH_IMP` record in this tab, or the stored bearer itself carries the `imp` claim (copied token). Never throws. */
export function viewingAsUser(): boolean {
    try {
        return hasImpersonationRecord() || tokenImpersonationSessionId(storedBearer()) !== null;
    } catch {
        return false;
    }
}

/** A refusal because this tab views as a user: 403 `{"code":"impersonation_forbidden"}` (LightHttp rewrites its message). */
export function isImpersonationForbiddenError(err: unknown): boolean {
    const e = err as any;
    if (!e) return false;
    if (e.response?.code === 'impersonation_forbidden' && (e.status === 403 || e.status == null)) return true;
    return e.message === IMPERSONATION_FORBIDDEN_MESSAGE;
}

/**
 * Props spread LAST onto a button whose endpoint is always refused while viewing as a user: disabled + the tooltip.
 * Empty when `active` is falsy, so a normal visit renders exactly as before.
 */
export function viewAsUserBlock(active: boolean | undefined): { disabled?: boolean; title?: string; 'data-view-as-user-blocked'?: 'true' } {
    return active ? { disabled: true, title: VIEW_AS_USER_UNAVAILABLE_TOOLTIP, 'data-view-as-user-blocked': 'true' } : {};
}
